import { getAnalystCoverage } from '@simplywallst/services';
import type { QueryFunctionContext } from '@tanstack/react-query';

export const getQueryKey = (companyId: string) =>
  ['ANALYSTS', companyId] as const;

export async function queryFn(
  context: QueryFunctionContext<ReturnType<typeof getQueryKey>>
) {
  const [, companyId] = context.queryKey;
  const response = await getAnalystCoverage({ lookupVal: companyId });
  return response.data.data;
}
